"use client";
import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "swiper/css";

interface CarouselProps {
  children: React.ReactNode[];
}

const TopMerchantsCarousel = ({ children }: CarouselProps) => {
  const prevRef = useRef<HTMLButtonElement>(null);
  const nextRef = useRef<HTMLButtonElement>(null);
  const [swiperReady, setSwiperReady] = useState(false);

  return (
    <div className="relative group/wrap">

      {/* ── Prev button ── */}
      <button
        ref={prevRef}
        aria-label="Previous"
        className="carousel-prev absolute -left-5 top-[40%] -translate-y-1/2 z-20
          w-10 h-10 rounded-xl bg-white border-2 border-slate-200
          flex items-center justify-center text-slate-400
          hover:bg-indigo-950 hover:border-indigo-950 hover:text-white
          opacity-0 group-hover/wrap:opacity-100
          shadow-[0_4px_16px_rgba(0,0,0,0.08)]
          transition-all duration-300 active:scale-90"
      >
        <ChevronLeft size={16} strokeWidth={2.5} />
      </button>

      {/* ── Next button ── */}
      <button
        ref={nextRef}
        aria-label="Next"
        className="carousel-next absolute -right-5 top-[40%] -translate-y-1/2 z-20
          w-10 h-10 rounded-xl bg-white border-2 border-slate-200
          flex items-center justify-center text-slate-400
          hover:bg-indigo-950 hover:border-indigo-950 hover:text-white
          opacity-0 group-hover/wrap:opacity-100
          shadow-[0_4px_16px_rgba(0,0,0,0.08)]
          transition-all duration-300 active:scale-90"
      >
        <ChevronRight size={16} strokeWidth={2.5} />
      </button>

      {/* ── Swiper ── */}
      <Swiper
        modules={[Autoplay, Navigation]}
        spaceBetween={16}
        slidesPerView={2}
        loop
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        navigation={{
          prevEl: ".carousel-prev",
          nextEl: ".carousel-next",
        }}
        onSwiper={() => setSwiperReady(true)}
        breakpoints={{
          480:  { slidesPerView: 3, spaceBetween: 16 },
          768:  { slidesPerView: 4, spaceBetween: 20 },
          1024: { slidesPerView: 5, spaceBetween: 24 },
          1280: { slidesPerView: 6, spaceBetween: 24 },
        }}
        className="w-full !pb-2"
      >
        {children.map((card, index) => (
          <SwiperSlide key={index} className="!h-auto py-3">
            {card}
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default TopMerchantsCarousel;
